module.exports = __webpack_public_path__ + "img/20220310_151443.0136aede.jpg";